<template>
  <el-form
    status-icon
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    v-loading="formLoading"
    label-width="120px"
    class="carpo-form demo-ruleForm"
  >
    <VehicleSelect
      prop="vehicle_id"
      :model="ruleForm.vehicle_id"
      @update="ruleForm.vehicle_id = $event"
      :disabled="ruleForm.disabled"
    />
    <!-- <el-tooltip class="item" effect="dark" :content="$t('SEARCH_BY', {
      type:
        $t('VEHCILE_NAME') + ' ' + $t('AND') + ' ' + $t('LICENSE_PLATE'),
    })
      " placement="top">
      <el-form-item :label="$t('VEHICLE_TITLE')" prop="vehicle_id" class="information" v-loading="loading"
        element-loading-spinner="el-icon-loading">
        <el-select v-model="ruleForm.vehicle_id" filterable @change="formChanged" :placeholder="$t('SELECT_PLACEHOLDER')">
          <el-option v-for="item in cars" :key="item.id" :label="item.license_plate.substring(7, 9) +
            '|' +
            item.license_plate.substring(4, 7) +
            alphaList.find(
              (i) => i.code == item.license_plate.substring(2, 4)
            ).char +
            item.license_plate.substring(0, 2) +
            ' - ' +
            item.vehicle.fa_title
            " :value="item.id">
            <LicenseOption :license_plate="item.license_plate" :vehicle="item.vehicle" :chars="alphaList" />
          </el-option>
        </el-select>
      </el-form-item>
    </el-tooltip> -->
    <el-form-item :label="$t('DATE_RANGE')" prop="dateRange">
      <date-picker
        v-model="ruleForm.dateRange"
        color="#151515"
        class="el-input__inner"
        type="date"
        range
        format="YYYY-MM-DD"
        display-format="jYYYY/jMM/jDD"
        :clearable="true"
        :editable="false"
        :placeholder="$t('SELECT_DATE_RANGE')"
        @change="formChanged"
        :max="maxDate"
      />
    </el-form-item>
    <el-form-item :label="$t('TIME_SELECTION')" prop="value1">
      <el-time-picker
        is-range
        v-model="ruleForm.value1"
        :range-separator="$t('TO')"
        :start-placeholder="$t('START_TIME')"
        :end-placeholder="$t('END_TIME')"
        @change="formChanged"
      ></el-time-picker>
    </el-form-item>
    <el-form-item
      v-if="type === 'overview'"
      :label="$t('MIN_DURATION')"
      prop="min_duration"
    >
      <el-input
        type="text"
        v-model="ruleForm.min_duration"
        @input="ruleForm.min_duration = toEnglish(ruleForm.min_duration)"
        autocomplete="off"
      ></el-input>
    </el-form-item>

    <el-form-item class="flex justify-end col-span-full mt-4">
      <slot></slot>
      <el-button type="success" @click="submitForm('ruleForm')">
        {{ $t('SEARCH') }}
      </el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { v2trips, v2overview } from '@/api/reports'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'

export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
  },

  components: {
    VehicleSelect,
  },
  mixins: [jalaliToGregorian, gregorianToJalali],
  data() {
    return {
      tableData: [],
      lastData: null,
      cars: [],
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
      loading: true,
      formLoading: false,
      selectedId: null,
      ruleForm: {
        dateRange: null,
        vehicle_id: '',
        min_duration: '5',
        value1: [new Date(2021, 9, 10, 0, 0), new Date(2021, 9, 10, 23, 59)],
      },

      rules: {
        vehicle_id: {
          required: true,
          message: this.$i18n.t('REQUIRED_CHOOSE', {
            type: this.$i18n.t('VEHICLE_TITLE'),
          }),
          trigger: 'blur',
        },
        dateRange: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('DATE_RANGE'),
            }),
            trigger: 'blur',
          },
        ],

        value1: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('TIME'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    formChanged() {
      this.$emit('path', null)

      this.$emit('anomaly', [])
      this.$emit('vehicleId', null)
      this.$emit('startDateTime', null)
      this.$emit('endDateTime', null)
      this.$emit('minDuration', null)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        this.formChanged()

        if (valid) {
          this.formLoading = true

          let startTime = this.ruleForm.value1[0]
          let endTime = this.ruleForm.value1[1]

          const startDate = new Date(this.ruleForm.dateRange[0])
          startDate.setHours(startTime.getHours())
          startDate.setMinutes(startTime.getMinutes())
          startDate.setSeconds(startTime.getSeconds())

          const endDate = new Date(this.ruleForm.dateRange[1])
          endDate.setHours(endTime.getHours())
          endDate.setMinutes(endTime.getMinutes())
          endDate.setSeconds(endTime.getSeconds())

          const actionPayload = [
            this.ruleForm.vehicle_id,
            startDate.getTime() / 1000,
            endDate.getTime() / 1000,
            this.ruleForm.min_duration,
          ]

          if (this.type === 'default') {
            v2trips.api(actionPayload).then((res) => {
              this.formLoading = false

              if (res && res.points.length > 0) {
                if (this.lastData != null) {
                  this.$emit('realtime', true)
                }
                this.lastData = res
                this.$emit('path', res)
              } else {
                this.formChanged()
                this.$notify.error({
                  title: this.$i18n.t('NO_DATA_FOR_VEHICLE'),
                  duration: 5000,
                  customClass: 'error_msg',
                })
              }
            })
          } else if (this.type === 'overview') {
            v2overview.api(actionPayload).then((res) => {
              this.formLoading = false

              if (res) {
                if (this.lastData != null) {
                  this.$emit('realtime', true)
                }
                this.lastData = res
                this.$emit('path', res)
                this.$emit('vehicleId', this.ruleForm.vehicle_id)
                this.$emit('startDateTime', startDate.getTime() / 1000)
                this.$emit('endDateTime', endDate.getTime() / 1000)
                this.$emit('minDuration', this.ruleForm.min_duration)
              } else {
                this.lastData = null
                this.$emit('path', null)
                this.$emit('vehicleId', null)

                this.formChanged()

                this.$notify.error({
                  title: this.$i18n.t('NO_DATA_FOR_VEHICLE'),
                  duration: 5000,
                  customClass: 'error_msg',
                })
              }
            })
          }
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },

  computed: {
    maxDate() {
      const today = new Date()
      return today.toISOString().split('T')[0]
    },
  },
}
</script>
